module.exports = __webpack_public_path__ + "img/slide-bar-off_01.e7b4c639.png";